<script setup>
// Auth page root. Reads window.AUTH_INIT.mode and renders the matching form:
//   'login'           → LoginForm
//   'forgot'          → ForgotForm
//   'reset'           → ResetForm
//   'verify'          → VerifyView
//   'account-deleted' → AccountDeletedView
import { computed, ref } from 'vue'
import LoginForm  from './components/LoginForm.vue'
import ForgotForm from './components/ForgotForm.vue'
import ResetForm  from './components/ResetForm.vue'
import VerifyView         from './components/VerifyView.vue'
import AccountDeletedView from './components/AccountDeletedView.vue'
import TotpStep           from './components/TotpStep.vue'

const init = window.AUTH_INIT || {}
const mode = computed(() => init.mode || 'login')
const step = ref('login') // 'login' | 'totp'

// Defined here (not inline in the template) because Vue 3's template
// compiler does NOT include `window` in its known-globals allow-list:
// an inline `@redirect="path => { window.location.href = path }"` gets
// compiled as `_ctx.window.location.href`, and `_ctx.window` is
// undefined, throwing "Cannot read properties of undefined (reading
// 'location')". Hoisting the handler into <script setup> resolves
// `window` against the real global instead.
function onRedirect(path) {
  window.location.href = path || '/'
}
</script>

<template>
  <template v-if="mode === 'login'">
    <LoginForm
      v-if="step === 'login'"
      :csrf-token="init.csrfToken || ''"
      :redirect="init.redirect || '/'"
      :email="init.email || ''"
      :initial-error="init.error || ''"
      :initial-success="init.success || ''"
      :plan="init.plan || ''"
      :next="init.next || ''"
      @step="s => step = s"
    />
    <TotpStep
      v-else-if="step === 'totp'"
      :csrf-token="init.csrfToken || ''"
      @redirect="onRedirect"
    />
  </template>
  <ForgotForm
    v-else-if="mode === 'forgot'"
    :csrf-token="init.csrfToken || ''"
  />
  <ResetForm
    v-else-if="mode === 'reset'"
    :csrf-token="init.csrfToken || ''"
    :token="init.token || ''"
    :valid-token="!!init.validToken"
    :initial-error="init.error || ''"
  />
  <VerifyView
    v-else-if="mode === 'verify'"
    :csrf-token="init.csrfToken || ''"
    :sub-mode="init.subMode || 'pending'"
    :initial-error="init.error || ''"
    :initial-success="init.success || ''"
    :pending-email="init.pendingEmail || ''"
  />
  <AccountDeletedView v-else-if="mode === 'account-deleted'" />
</template>
